// UserSystemFieldsTable.js
import React from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const UserSystemFieldsTable = ({ user }) => {
    return (
        <Table size="small" aria-label="a dense table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">User ID</TableCell>
                    <TableCell align="center">User UUID</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell align="center">{user.userId}</TableCell>
                    <TableCell align="center">{user.userUuid}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

UserSystemFieldsTable.propTypes = {
    user: PropTypes.shape({
        userId: PropTypes.number.isRequired,
        userUuid: PropTypes.string.isRequired,
    }).isRequired,
};

export default UserSystemFieldsTable;
